<template lang="pug">
v-container(fluid class="pa-0 ma-0")
  v-expansion-panels(
    multiple
    :accordion="false"
    :flat="true"
    tile
    v-model="activePanel"
  )
    template(v-for="(message, index) in messages")
      v-divider(
        v-if="index > 0 || (index > 0 && index != activePanel[0])"
        class="tw-mt-4 tw-mb-4 tw-border tw-border-t-0 tw-border-gray-lighten-3"
      )
      v-expansion-panel(:key="index" active-class="k-mail-active-panel")
        v-expansion-panel-header(class="tw-p-0 tw-m-0  tw-min-h-0" hide-actions)
          v-row(no-gutters align="center" class="  ")
            v-col
              template(v-if="lead.email == message.sender_email")
                v-avatar(size="30" color="indigo lighten-4" class="tw-border-indigo-600 tw-border-solid tw-border-2 mx-1")
                  span(class="tw-font-bold tw-text-md tw-text-white") {{ generateInitials(lead.name) }}
                span {{ message.sender_email }}
              template(v-else-if="message.user")
                v-avatar(size="30" color="indigo lighten-4" class="tw-border-indigo-600 tw-border-solid tw-border-2 mx-1")
                  span(class="tw-font-bold tw-text-md tw-text-white") {{ generateInitials(message.user.name) }}
                span {{ message.sender_email }}
              template(v-else)
                div(class=" ml-4")
                  span {{ message.sender_email }}
            v-col(cols="auto")
              span(class=" tw-text-sm tw-pr-2 tw-text-gray-darken-2") {{ $moment(message.created_at).fromNow() }}

        v-expansion-panel-content(class="tw-p-0 tw-m-0 k-mail-content")
          div(class="tw-pt-2 tw-px-2 tw-pb-8 tw-mb-8")
            v-divider(class="tw-mb-4 ")
            div(v-if="message.body" v-dompurify-html="message.body")
</template>
<script>
export default {
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    generateInitials(fullName) {
      const names = fullName.split(' ');
      if (names.length > 1) {
        return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
      }
      return names[0].substring(0, 2).toUpperCase();
    },
  },
  computed: {
    lead() {
      return this.$store.getters['leads/current_lead'];
    },
    activePanel: {
      get() {
        return [this.messages.length - 1];
      },
      set(value) {
        return value;
      },
    },
  },
};
</script>
<style lang="scss">
.k-mail-content .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.k-mail-active-panel {
  margin: 0px !important;
  margin-top: -16px !important;
  margin-bottom: -16px !important;
  background-color: rgb(247, 247, 247) !important;
}

.k-mail-active-panel .v-expansion-panel-header {
  background-color: rgb(247, 247, 247) !important;
}
</style>
